import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, StaticProvider, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormGroupDirective, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { QuillEditorComponent } from 'ngx-quill';

export const dynamicControlProvider: StaticProvider = {
  provide: ControlContainer,
  useFactory: () => inject(ControlContainer, { skipSelf: true }),
};

@Component({
  selector: 'app-rich-text-form-field',
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, TranslateModule, QuillEditorComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RichTextFormFieldComponent,
      multi: true,
    },
  ],
  viewProviders: [dynamicControlProvider],
  templateUrl: './rich-text-form-field.component.html',
  styleUrl: './rich-text-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RichTextFormFieldComponent implements ControlValueAccessor {
  @Input() formControlName!: string;
  @Input() labelT!: string;

  @ViewChild(QuillEditorComponent, { static: true })
  quillComponent!: QuillEditorComponent;

  public parentGroupDir = inject(ControlContainer);

  public get formDirective() {
    return this.parentGroupDir.formDirective as FormGroupDirective;
  }

  writeValue(obj: any): void {
    this.quillComponent.writeValue(obj);
  }
  registerOnChange(fn: any): void {
    this.quillComponent.registerOnChange(fn);
  }
  registerOnTouched(fn: any): void {
    this.quillComponent.registerOnTouched(fn);
  }
  setDisabledState?(isDisabled: boolean): void {
    this.quillComponent.setDisabledState(isDisabled);
  }
}
